module.exports = __webpack_public_path__ + "img/zhuyingshao.5e078c04.png";